export default "__VITE_ASSET__Bat7pSXl__"